<template>
    <div class="page-column">
        <Header/>
        <Search />
        <router-view></router-view>
    </div>
</template>

<script>
import Header from '../layout/Header.vue'
import Search from './components/home/Search.vue'

export default {
  components: {
    Header,
    Search,
  },
  data () {
    return {
    }
  },
  methods: {
   
  },
}
</script>

<style lang="scss" scoped>
.page-column {
    width: 100%;
    //   display: flex;
    //   flex-grow: 1;
    //   flex-direction: column;
 
  
}

</style>


// WEBPACK FOOTER //
// src/daoba-match/views/stadium/Home.vue